import { IconNames } from './icons'

export type ShipmentStatusCategory =
  | 'pending'
  | 'not_yet_shipped'
  | 'shipped'
  | 'completed'
  | 'delivered'
  | 'in_transit'
  | 'cancelled'
  | 'rejected'
  | 'exception'

export type ShipmentStatusTypesType = Record<
  string,
  {
    label: string
    category: ShipmentStatusCategory
    message: string
  }
>

export const ShipmentStatusCategories: Record<
  ShipmentStatusCategory,
  {
    icon: IconNames
  }
> = {
  not_yet_shipped: {
    icon: 'clock',
  },
  pending: {
    icon: 'clock',
  },
  shipped: {
    icon: 'check-circle-outline',
  },
  completed: {
    icon: 'check-circle-filled',
  },
  delivered: {
    icon: 'check-circle-filled',
  },
  in_transit: {
    icon: 'travel',
  },
  cancelled: {
    icon: 'error-circle-filled',
  },
  rejected: {
    icon: 'error-circle-filled',
  },
  exception: {
    icon: 'error-circle-filled',
  },
}

export const shipmentStatusTypes: ShipmentStatusTypesType = {
  created: {
    label: 'Order created',
    category: 'not_yet_shipped',
    message: 'Your bag order has been created',
  },
  pending: {
    label: 'Booked XX days left for pick up/dropoff',
    category: 'not_yet_shipped',
    message: 'Your bag is pending further information',
  },
  pending_shipment: {
    label: 'Pending further info',
    category: 'not_yet_shipped',
    message: 'Your bag is pending further information',
  },
  shipped: {
    label: 'Shipped',
    category: 'shipped',
    message: 'Your bag has been shipped',
  },
  in_transit: {
    label: 'In Transit',
    category: 'in_transit',
    message: 'Your bag is in transit',
  },
  exception: {
    label: 'Exception',
    category: 'exception',
    message: 'There is an issue with your bag. Please contact support.',
  },
  cancelled: {
    label: 'Cancelled',
    category: 'cancelled',
    message: 'Your bag has been cancelled',
  },
  rejected: {
    label: 'Processing',
    category: 'rejected',
    message: 'Your bag has been rejected',
  },
  delivered: {
    label: 'Delivered',
    category: 'completed',
    message: 'Your bag has been delivered',
  },
}

export type ShipmentStatusTypesKeys = keyof typeof shipmentStatusTypes

export const getShipmentStatusMeta = (status: ShipmentStatusTypesKeys) =>
  shipmentStatusTypes[status]

export const getShipmentStatusIcon = (status: ShipmentStatusTypesKeys) =>
  ShipmentStatusCategories[shipmentStatusTypes[status]?.category]?.icon
